const logoutUrl = process.env.VUE_APP_LOGOUT_URL || "/logout";
const authServer = process.env.VUE_APP_AUTHENTICATION_URL;

export const deleteCurrentAuth = (): void => {
  localStorage.removeItem("user");
  localStorage.removeItem("accessToken");
  const currentUrl = window.location.href;
  if (currentUrl.includes("redirect=")) {
    window.location.href = `${authServer}?${currentUrl.split("?")[1]}`;
  } else if (currentUrl !== logoutUrl) {
    window.location.href = logoutUrl;
  }
};
